<template>
	<div>
		<van-popup v-model="city_show" position="bottom" closeable
			style="border-radius: 8px 8px 0 0;background-color: #F6F7F9;">
			<div class="cmbc_pop width_100">
				<div class="cmbc_pop_title width_100 text_align_center font_size_34 color_333333 font_weight_600">请选择</div>
				<div class="cmbc_pop_search width_100 display_center_center bg_FFFFFF border_radius_16">
					<van-field
					    v-model="filter_city"
					    placeholder="请输入"
						@input="filterCity"
					  />
					  <van-icon v-if="filter_city.length>0" @click="removeFilterCity()" name="cross" />
				</div>
				<div v-if="filter_city.length==0" class="cmbc_pop_list width_100 border_radius_16 bg_FFFFFF">
					<van-index-bar :index-list="indexList" :sticky="false" highlight-color="#F77F28">
						<div v-for="(item1,index1) in city_list" :key="'index'+index1">
							<van-index-anchor :index="item1.lettter"></van-index-anchor>
							<div v-for="(item2,index2) in item1.list" :key="'index'+index2" class="cmbc_pop_list_item">
								<div class="cmbc_pop_list_block width_100 color_666666" @click="selectCity(item2)">{{item2.city}}</div>
							</div>
						</div>
					</van-index-bar>
				</div>
				<div v-else class="cmbc_pop_list width_100 border_radius_16 bg_FFFFFF">
					<div v-for="(item2,index2) in filter_city_list" :key="'index'+index2" class="cmbc_pop_list_item">
						<div class="cmbc_pop_list_block width_100 color_666666" @click="selectCity2(item2)">{{item2.city}}</div>
					</div>
				</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
	import {
		getCitys
	} from '../../src/api/api.js'
	export default {
		props: {
			
		},
		data() {
			return {
				city_show: false,
				
				filter_city:'',
				filter_city_list:[],
				
				city_list:[],
				indexList:[],
				
				city_id:'1101',
				city_name:'北京市',
				district_id:'',
				district_name:'全部',
			}
		},
		mounted() {
			this.$RCLoading.show();
			this.getCity()
		},
		methods: {
			removeFilterCity(){
				this.filter_city=''
			},
			filterCity(e){
				// // console.log(e);
				if(e.length==0){return}
				var filter_city_list=[]
				this.city_list.map((item_1)=>{
					item_1.list.map((item_2)=>{
						if(item_2.city.indexOf(e)>=0){
							filter_city_list.push(item_2)
						}
					})
				})
				// // console.log(filter_city_list);
				this.filter_city_list=filter_city_list
			},
			async getCity(){
				var $this = this
				try {
					var res=await getCitys()
					// // console.log(res);
					var index_list=[]
					res.data.map((item,index)=>{
						index_list.push(item.letter)
					})
					index_list=Array.from(new Set(index_list))
					// // console.log(index_list);
					this.indexList=index_list
					var az_list=[]
					index_list.map((item)=>{
						var params={
							lettter:item,
							list:[]
						}
						az_list.push(params)
					})
					// // console.log('az_list',az_list);
					az_list.map((item_1)=>{
						res.data.map((item_2)=>{
							if(item_1.lettter==item_2.letter){
								item_1.list.push(item_2)
							}
						})
					})
					// console.log(az_list);
					$this.city_list=az_list
					$this.$RCLoading.hide();
					
					$this.selectCityComplete()
					// $this.openCityPop()
					// $this.$loading.close();
					// $this.getPageListBefore()
				} catch (error) {
					//TODO handle the exception
				}
			},
			openCityPop() {
				this.city_show = true
			},
			closeCityPop() {
				this.city_show = false
			},
			selectCity(e){
				// // // console.log(e);
				this.city_id=e.cityId
				this.city_name=e.city
				
				this.district_id=''
				this.district_name='全部'
				
				this.closeCityPop()
				this.selectCityComplete()
			},
			selectCity2(e){
				this.city_id=e.cityId
				this.city_name=e.city
				
				this.district_id=''
				this.district_name='全部'
				
				this.closeCityPop()
				this.removeFilterCity()
				this.selectCityComplete()
			},
			selectCityComplete(){
				var params={
					city_id:this.city_id,
					city_name:this.city_name,
					district_id:'',
					district_name:'全部',
				}
				this.$emit('selectCityDistrict',params)
			},
		}
	}
</script>

<style lang="less" scoped="scoped">
	@vm_base: 1/750*100vw;
	.cmbc_pop {
		padding: 0 20*@vm_base 20*@vm_base 20*@vm_base;
	
		.cmbc_pop_title {
			padding: 40*@vm_base;
		}
		.cmbc_pop_search{
			margin-bottom: 20*@vm_base;
			padding: 0 20*@vm_base 0 0;
		}
	
		.cmbc_pop_list {
			height: 80vh;
			padding:0 20*@vm_base;
			overflow: hidden;
			overflow-y: auto;
		}
		.cmbc_pop_list_item{
			padding: 0 16px;
		}
		.cmbc_pop_list_block{
			padding: 20*@vm_base 0;
			border-bottom: 1*@vm_base solid #d9d9d9;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/pop_city.vue